import {ForumI18n} from '@/locales/base.message.locales';

export const forum: ForumI18n = {
  actions: 'Actions',
  last_topic: 'Last Topic',
  replies: 'Replies',
  search: 'Search',
  title: 'Forum',
  total: 'Total',
  message: {
    destroy: 'Delete Message',
    edit: 'Edit Message',
    edited: 'Edited',
    new: 'New Message',
    empty_replies: 'No replies',
    reason_for_reporting: 'Reason for reporting...',
  },
  topic: {
    destroy: 'Delete Topic',
    edit: 'Edit Topic',
    last_post: 'Last post by {0}',
    new: 'New Topic',
    show: 'Show Topic',
    title: 'Topics',
    report: 'Report',
  }, dialog: {
    confirm_destroy: 'You\'re sure to remove?'
  }

};
